import React, { useEffect, useState } from "react";
import { useCommonStore } from "@/store/useCommonStore";

const InitData = ( {children} ) => {
    const [loading,setLoading] = useState(false);
    const initFn = useCommonStore.use.initFn();
    const inited = useCommonStore.use.inited();
    useEffect(()=> {
        (async ()=>{
            setLoading(true);
            await initFn();
            setLoading(false);
        })();
    },[]);
    if(inited) return children;
    if(inited == false && loading == true) {
        return (<div>加载基础数据中</div>)
    } else {
        return (<div>基础数据加载失败，请联系系统管理员。</div>)
    }
};

export default InitData;